import { render, staticRenderFns } from "./RemarksBlock.vue?vue&type=template&id=d0036be8"
import script from "./RemarksBlock.vue?vue&type=script&lang=js"
export * from "./RemarksBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports